// extracted by mini-css-extract-plugin
module.exports = {"recall":"index_recall_1k9qG"};